import gql from 'graphql-tag';

export const getMultiChannelGroupRoles = gql`
  query getMultiChannelGroupRoles($ids: [UUID!]!, $permissions: [String!]!, $moduleCategories: [ModuleCategoryEnum!]!, $pagination: PaginationInput) {
    multiChannelGroupRoles(channelIds: $ids, permissions: $permissions, moduleCategories: $moduleCategories, pagination: $pagination) {
      items {
        _id
        name
      }
      pageInfo {
        start
        total
        perPage
      }
    }
  }
`;
